import vanityEnGB from '../../hardcodedProductData/bda/vanity-en-GB.json';
import vanityDaDk from '../../hardcodedProductData/bda/vanity-da-DK.json';
import vanityTestEnGb from '../../hardcodedProductData/bda/vanity-test-en-GB.json';

export type ConfigurableProperty = {
    displayName: string; // the human-readable name of a property
    displayHeader?: string; // optional header for the build step
    displayDescription?: string; // optional long-form description of the property
    displayNotice?: string; // optional highlighted note for this property (e.g. "you can change this later")
    propertyValues: {
        [propertyValueName: string]: {
            // intersectioned with concrete type
            displayText: string; // text in the UI, e.g. "White Gloss"
            displayHint?: string; // optional hint associated with the concrete choice (e.g. "this panel with a choice of handles")
            displayImage: string;
        };
    };
};

export type AttachmentMap = {
    [propertyAttachmentOption: string]: {
        displayName: string;
        options: { [attachmentPointName: string]: string };
    };
};

export type ConfiguratorDefinition = {
    configurationSpaceId: string; // the id used when calling up to the compatibility service
    buildStepHeader: string;
    styleStepHeader: string;
    buildPropertyWhitelist: string[]; // both which properties from the compatibility data to display as options in the build step and their order
    stylePropertyWhitelist: string[]; // both which properties from the compatibility data to display as options in the style step and their order
    configurableProperties: {
        [propertyName: string]: ConfigurableProperty;
    };
    attachmentMap: AttachmentMap; // any option presented in the UI from a particles' attachments schema, e.g. "rearCenter" => "Center" - see attachmentOptions in ConfigurableProperty
    propertyPriorities: { [property: string]: string[] }; // phase 2, probably
};

export const fetchConfiguratorDefinition = (
    id: string,
    tenant?: string,
): Promise<ConfiguratorDefinition> => {
    // TODO: Service for these docs?
    switch (id) {
        case 'vanity-en-GB':
            return Promise.resolve(vanityEnGB as ConfiguratorDefinition);
        case 'vanity-da-DK':
            // TODO: actual danish translation of this doc!
            return Promise.resolve(vanityDaDk as ConfiguratorDefinition);
        case 'vanity-test-en-GB':
            return Promise.resolve(vanityTestEnGb as ConfiguratorDefinition);
        default:
            if (!tenant) {
                return Promise.reject(new Error('not provided with tenant or BDA configurator ID'));
            }
            return import(`../../hardcodedProductData/${tenant}/${id}.json`);
    }
};
